export default __webpack_public_path__ + "static/media/stripe_light_crop.974ff991.png";